var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBankLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "OBJECTS",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 140.204,
    height: 78.277,
    viewBox: "0 0 140.204 78.277",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#902df9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7329e8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: 0.499,
    x2: 1,
    y2: 0.499,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#902df9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6833d2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_228",
    "data-name": "Group 228"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_630",
    "data-name": "Rectangle 630",
    width: 112.234,
    height: 51.713,
    transform: "translate(13.717 21.934)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_211",
    "data-name": "Group 211",
    transform: "translate(19.037 45.065)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_631",
    "data-name": "Rectangle 631",
    width: 24.894,
    height: 18.128,
    fill: "#8b39ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_632",
    "data-name": "Rectangle 632",
    width: 23.48,
    height: 16.715,
    transform: "translate(0.707 0.707)",
    fill: "#442491"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_210",
    "data-name": "Group 210",
    transform: "translate(0.707 0.707)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_346",
    "data-name": "Path 346",
    d: "M54.288,74.36v3.4L52.96,79.09H49.55Z",
    transform: "translate(-30.808 -62.375)",
    fill: "#8b39ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_347",
    "data-name": "Path 347",
    d: "M39.867,58.93,25.42,73.377v-3.41L36.465,58.93Z",
    transform: "translate(-25.42 -58.93)",
    fill: "#8b39ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_348",
    "data-name": "Path 348",
    d: "M41.987,58.93,25.42,75.5v-.722L41.273,58.93Z",
    transform: "translate(-25.42 -58.93)",
    fill: "#8b39ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_349",
    "data-name": "Path 349",
    d: "M52.716,67.31v.715l-9.491,9.491H42.51Z",
    transform: "translate(-29.236 -60.801)",
    fill: "#8b39ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_350",
    "data-name": "Path 350",
    d: "M55.641,80.41v.031H55.61Z",
    transform: "translate(-32.161 -63.726)",
    fill: "#8b39ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_351",
    "data-name": "Path 351",
    d: "M33.513,58.93,25.42,67.023V65.61l6.687-6.68Z",
    transform: "translate(-25.42 -58.93)",
    fill: "#8b39ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_213",
    "data-name": "Group 213",
    transform: "translate(94.712 45.065)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_633",
    "data-name": "Rectangle 633",
    width: 24.894,
    height: 18.128,
    fill: "#8b39ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_634",
    "data-name": "Rectangle 634",
    width: 23.48,
    height: 16.715,
    transform: "translate(0.707 0.707)",
    fill: "#442491"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_212",
    "data-name": "Group 212",
    transform: "translate(0.707 0.707)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_352",
    "data-name": "Path 352",
    d: "M151.718,74.36v3.4L150.39,79.09h-3.41Z",
    transform: "translate(-128.238 -62.375)",
    fill: "#8b39ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_353",
    "data-name": "Path 353",
    d: "M137.3,58.93,122.85,73.377v-3.41L133.895,58.93Z",
    transform: "translate(-122.85 -58.93)",
    fill: "#8b39ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_354",
    "data-name": "Path 354",
    d: "M139.417,58.93,122.85,75.5v-.722L138.7,58.93Z",
    transform: "translate(-122.85 -58.93)",
    fill: "#8b39ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_355",
    "data-name": "Path 355",
    d: "M150.144,67.31v.715l-9.491,9.491h-.722Z",
    transform: "translate(-126.664 -60.801)",
    fill: "#8b39ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_356",
    "data-name": "Path 356",
    d: "M153.071,80.41v.031h-.031Z",
    transform: "translate(-129.591 -63.726)",
    fill: "#8b39ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    "data-name": "Path 357",
    d: "M130.943,58.93l-8.093,8.093V65.61l6.68-6.68Z",
    transform: "translate(-122.85 -58.93)",
    fill: "#8b39ff"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_635",
    "data-name": "Rectangle 635",
    width: 140.204,
    height: 2.384,
    transform: "translate(0 21.414)",
    fill: "#442491"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_636",
    "data-name": "Rectangle 636",
    width: 140.204,
    height: 4.186,
    transform: "translate(0 74.09)",
    fill: "#442491"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_637",
    "data-name": "Rectangle 637",
    width: 132.895,
    height: 4.186,
    transform: "translate(3.651 69.904)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_358",
    "data-name": "Path 358",
    d: "M6.28,21.554,71.5,0l65.228,21.554Z",
    transform: "translate(-1.402)",
    fill: "#902df9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_359",
    "data-name": "Path 359",
    d: "M36.27,18.976,78.2,5.12l41.935,13.856Z",
    transform: "translate(-8.099 -1.143)",
    fill: "#442491"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_216",
    "data-name": "Group 216",
    transform: "translate(60.164 45.903)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_638",
    "data-name": "Rectangle 638",
    width: 10.229,
    height: 23.923,
    fill: "#8b39ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_639",
    "data-name": "Rectangle 639",
    width: 7.185,
    height: 16.132,
    transform: "translate(1.522 1.561)",
    fill: "#442491"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_214",
    "data-name": "Group 214",
    transform: "translate(1.522 1.561)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_360",
    "data-name": "Path 360",
    d: "M86.6,61.11v1.414L79.42,69.716v-3.41l5.2-5.2Z",
    transform: "translate(-79.42 -61.11)",
    fill: "#8b39ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_361",
    "data-name": "Path 361",
    d: "M86.6,70.67v3.4l-5.282,5.3h-1.9v-1.5Z",
    transform: "translate(-79.42 -63.245)",
    fill: "#8b39ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_362",
    "data-name": "Path 362",
    d: "M86.6,68.75v.715l-7.185,7.2v-.722Z",
    transform: "translate(-79.42 -62.816)",
    fill: "#8b39ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_363",
    "data-name": "Path 363",
    d: "M83.894,61.11,79.42,65.584V64.178l3.068-3.068Z",
    transform: "translate(-79.42 -61.11)",
    fill: "#8b39ff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_640",
    "data-name": "Rectangle 640",
    width: 0.497,
    height: 2.687,
    transform: "translate(9.165 12.412)",
    fill: "#442491"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_641",
    "data-name": "Rectangle 641",
    width: 7.185,
    height: 1.142,
    transform: "translate(1.522 13.189)",
    fill: "#8b39ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_642",
    "data-name": "Rectangle 642",
    width: 10.229,
    height: 23.923,
    transform: "translate(10.322)",
    fill: "#8b39ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_643",
    "data-name": "Rectangle 643",
    width: 7.185,
    height: 16.132,
    transform: "translate(11.845 1.561)",
    fill: "#442491"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_215",
    "data-name": "Group 215",
    transform: "translate(11.845 1.561)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_364",
    "data-name": "Path 364",
    d: "M99.9,61.11v1.414L92.71,69.716v-3.41l5.2-5.2Z",
    transform: "translate(-92.71 -61.11)",
    fill: "#8b39ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_365",
    "data-name": "Path 365",
    d: "M99.9,70.67v3.4l-5.289,5.3h-1.9v-1.5Z",
    transform: "translate(-92.71 -63.245)",
    fill: "#8b39ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_366",
    "data-name": "Path 366",
    d: "M99.9,68.75v.715l-7.192,7.2v-.722Z",
    transform: "translate(-92.71 -62.816)",
    fill: "#8b39ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_367",
    "data-name": "Path 367",
    d: "M97.184,61.11,92.71,65.584V64.178l3.068-3.068Z",
    transform: "translate(-92.71 -61.11)",
    fill: "#8b39ff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_644",
    "data-name": "Rectangle 644",
    width: 0.497,
    height: 2.687,
    transform: "translate(10.889 12.412)",
    fill: "#442491"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_645",
    "data-name": "Rectangle 645",
    width: 7.185,
    height: 1.142,
    transform: "translate(11.845 13.189)",
    fill: "#8b39ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_217",
    "data-name": "Group 217",
    transform: "translate(23.775 33.103)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_646",
    "data-name": "Rectangle 646",
    width: 3.021,
    height: 1.282,
    fill: "#902df9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_647",
    "data-name": "Rectangle 647",
    width: 3.021,
    height: 1.282,
    transform: "translate(1.685 1.608)",
    fill: "#902df9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_218",
    "data-name": "Group 218",
    transform: "translate(73.251 39.597)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_648",
    "data-name": "Rectangle 648",
    width: 3.021,
    height: 1.282,
    fill: "#902df9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_649",
    "data-name": "Rectangle 649",
    width: 3.021,
    height: 1.282,
    transform: "translate(1.685 1.608)",
    fill: "#902df9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_219",
    "data-name": "Group 219",
    transform: "translate(109.632 65.104)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_650",
    "data-name": "Rectangle 650",
    width: 3.021,
    height: 1.282,
    fill: "#902df9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_651",
    "data-name": "Rectangle 651",
    width: 3.021,
    height: 1.282,
    transform: "translate(1.685 1.608)",
    fill: "#902df9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_220",
    "data-name": "Group 220",
    transform: "translate(103.434 33.103)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_652",
    "data-name": "Rectangle 652",
    width: 3.021,
    height: 1.282,
    transform: "translate(1.685)",
    fill: "#902df9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_653",
    "data-name": "Rectangle 653",
    width: 3.021,
    height: 1.282,
    transform: "translate(0 1.608)",
    fill: "#902df9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_221",
    "data-name": "Group 221",
    transform: "translate(49.29 37.375)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_654",
    "data-name": "Rectangle 654",
    width: 3.021,
    height: 1.282,
    transform: "translate(1.693)",
    fill: "#902df9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_655",
    "data-name": "Rectangle 655",
    width: 3.021,
    height: 1.282,
    transform: "translate(0 1.616)",
    fill: "#902df9"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_656",
    "data-name": "Rectangle 656",
    width: 3.021,
    height: 1.282,
    transform: "translate(27.814 40.404)",
    fill: "#902df9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_657",
    "data-name": "Rectangle 657",
    width: 3.021,
    height: 1.282,
    transform: "translate(26.967 64.467)",
    fill: "#902df9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_658",
    "data-name": "Rectangle 658",
    width: 3.021,
    height: 1.282,
    transform: "translate(68.646 31.651)",
    fill: "#902df9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_659",
    "data-name": "Rectangle 659",
    width: 3.021,
    height: 1.282,
    transform: "translate(83.224 34.711)",
    fill: "#902df9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_660",
    "data-name": "Rectangle 660",
    width: 3.021,
    height: 1.282,
    transform: "translate(115.015 40.404)",
    fill: "#902df9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_226",
    "data-name": "Group 226",
    transform: "translate(7.122 26.455)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_222",
    "data-name": "Group 222"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_661",
    "data-name": "Rectangle 661",
    width: 14.556,
    height: 3.961,
    transform: "translate(2.703)",
    fill: "#442491"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_662",
    "data-name": "Rectangle 662",
    width: 19.954,
    height: 3.961,
    transform: "translate(0 39.488)",
    fill: "#442491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_368",
    "data-name": "Path 368",
    d: "M26.882,83.759H13.22l.186-3.969H26.7Z",
    transform: "translate(-10.074 -44.271)",
    fill: "#442491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_369",
    "data-name": "Path 369",
    d: "M26.749,70.718H13.46L14.951,39.16H25.258Z",
    transform: "translate(-10.128 -35.199)",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_223",
    "data-name": "Group 223",
    transform: "translate(28.505)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_663",
    "data-name": "Rectangle 663",
    width: 14.556,
    height: 3.961,
    transform: "translate(2.695)",
    fill: "#442491"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_664",
    "data-name": "Rectangle 664",
    width: 19.954,
    height: 3.961,
    transform: "translate(0 39.488)",
    fill: "#442491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_370",
    "data-name": "Path 370",
    d: "M63.582,83.759H49.92l.186-3.969H63.4Z",
    transform: "translate(-46.774 -44.271)",
    fill: "#442491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_371",
    "data-name": "Path 371",
    d: "M63.449,70.718H50.16L51.651,39.16H61.958Z",
    transform: "translate(-46.828 -35.199)",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_224",
    "data-name": "Group 224",
    transform: "translate(77.617)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_665",
    "data-name": "Rectangle 665",
    width: 14.556,
    height: 3.961,
    transform: "translate(2.695)",
    fill: "#442491"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_666",
    "data-name": "Rectangle 666",
    width: 19.954,
    height: 3.961,
    transform: "translate(0 39.488)",
    fill: "#442491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_372",
    "data-name": "Path 372",
    d: "M126.812,83.759H113.15l.186-3.969h13.289Z",
    transform: "translate(-110.004 -44.271)",
    fill: "#442491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_373",
    "data-name": "Path 373",
    d: "M126.679,70.718H113.39l1.491-31.558h10.307Z",
    transform: "translate(-110.058 -35.199)",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_225",
    "data-name": "Group 225",
    transform: "translate(105.462)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_667",
    "data-name": "Rectangle 667",
    width: 14.556,
    height: 3.961,
    transform: "translate(2.703)",
    fill: "#442491"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_668",
    "data-name": "Rectangle 668",
    width: 19.954,
    height: 3.961,
    transform: "translate(0 39.488)",
    fill: "#442491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_374",
    "data-name": "Path 374",
    d: "M162.665,83.759H149.01l.179-3.969h13.3Z",
    transform: "translate(-145.857 -44.271)",
    fill: "#442491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_375",
    "data-name": "Path 375",
    d: "M162.537,70.718h-13.3l1.491-31.558h10.315Z",
    transform: "translate(-145.908 -35.199)",
    fill: "url(#linear-gradient-3)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_227",
    "data-name": "Group 227",
    transform: "translate(55.946 9.965)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_376",
    "data-name": "Path 376",
    d: "M77.863,17.56c0,1.157-.955,1.709-2.392,1.709H72.03V12.83h3.332c1.437,0,2.338.513,2.338,1.709a1.366,1.366,0,0,1-.986,1.507,1.389,1.389,0,0,1,1.157,1.507Zm-2.594-2.113a.663.663,0,0,0,.66-.722A.677.677,0,0,0,75.207,14H73.84v1.445Zm.047,2.618a.66.66,0,0,0,.715-.722.675.675,0,0,0-.715-.722H73.832v1.445h1.476Z",
    transform: "translate(-72.03 -12.83)",
    fill: "#442491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_377",
    "data-name": "Path 377",
    d: "M84.649,19.269l-.357-1.181H82.039l-.357,1.181H79.81l2.136-6.439h2.416l2.144,6.439H84.641Zm-.738-2.447-.746-2.478-.746,2.478Z",
    transform: "translate(-73.767 -12.83)",
    fill: "#442491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_378",
    "data-name": "Path 378",
    d: "M95.306,12.84v6.439H93.364l-2.307-3.588v3.588H89.24V12.84h1.942l2.307,3.6v-3.6Z",
    transform: "translate(-75.873 -12.832)",
    fill: "#442491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_379",
    "data-name": "Path 379",
    d: "M100.265,15.587l2-2.75h2.1l-2.423,3.216,2.454,3.216h-2.136l-2-2.75v2.75H98.44V12.83h1.818v2.75Z",
    transform: "translate(-77.927 -12.83)",
    fill: "#442491"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_380",
    "data-name": "Path 380",
    d: "M77.473,17.17c0,1.157-.955,1.709-2.392,1.709H71.64V12.44h3.332c1.437,0,2.338.513,2.338,1.709a1.366,1.366,0,0,1-.986,1.507,1.389,1.389,0,0,1,1.157,1.507Zm-2.594-2.113a.663.663,0,0,0,.66-.722.677.677,0,0,0-.722-.722H73.45v1.445Zm.047,2.618a.66.66,0,0,0,.715-.722.675.675,0,0,0-.715-.722H73.442v1.445h1.476Zm7.588,1.2L82.157,17.7H79.9l-.357,1.181H77.675l2.136-6.439h2.416l2.144,6.439H82.506Zm-.738-2.447-.746-2.478-.746,2.478Zm9.289-3.985v6.439H89.124L86.817,15.3v3.588H85V12.448h1.942l2.307,3.6v-3.6h1.817Zm2.9,2.75,2-2.75h2.1l-2.423,3.216,2.454,3.216H95.951l-2-2.75v2.75H92.137V12.44h1.817v2.75Z",
    transform: "translate(-15.997 -2.778)",
    fill: "#902df9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_669",
    "data-name": "Rectangle 669",
    width: 132.895,
    height: 2.843,
    transform: "translate(3.651 23.837)",
    fill: "#902df9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankLogo);
export default __webpack_public_path__ + "static/media/BankLogo.18f44eacc5db23ae1f2bb27d27ecbc0f.svg";
export { ForwardRef as ReactComponent };